export const blackColors = [
  "#000000",
  "#434343",
  "#666666",
  "#999999",
  "#B7B7B7",
  "#CCCCCC",
  "#D9D9D9"
];
export const redColors = [
  "#660100",
  "#7F0100",
  "#990100",
  "#B20200",
  "#CC0200",
  "#E50200",
  "#FF0300"
];
export const colors = [...blackColors, ...redColors];
export const defaultColor = blackColors[0];
export const defaultRubricColor = redColors[redColors.length - 2];
